import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
  card: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    margin: '0 40px'
  },
  toolbarContainer: {
    borderBottom: '1px solid #D0E9FF'
  },
  paginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  root: {
    '& > .MuiToolbar-root': {
      borderTop: '1px solid #D0E9FF'
    },
    '& .MuiTableCell-head, & .MuiTableCell-head .MuiButton-root': {
      color: '#4277C6',
      textTransform: 'uppercase',
      fontSize: '12px',
      fontWeight: 600
    },
    '& .MuiTableCell-head': {
      borderColor: '#D0E9FF',
    },
    '& .MuiButton-label *': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777',
      fontWeight: 500
    },
    '& .MuiCheckbox-root': {
      color: '#4B6FC2'
    },
    '& .MuiTableFooter-root': {
      background: '#E7F0FF',
      color: '#4B6FC2',
      '& .MuiSelect-icon, & .MuiTablePagination-root': {
        color: '#4B6FC2'
      },
      '& .MuiIconButton-root.Mui-disabled': {
        color: '#4B6FC2',
        opacity: '0.44'
      }
    }
  },
}));
